function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.82 6.24H2.03A1.54 1.54 0 00.5 7.89l.65 9.06a5 5 0 005 4.66h13.33a5 5 0 005-4.66l.66-9.06a1.55 1.55 0 00-1.54-1.65z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.73 6.43C7.73 3.17 10.01.5 12.79.5c2.79 0 5.06 2.67 5.06 5.93"
});

var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "cart",
    viewBox: "-1 0 27.65 22.11"
  }, props), _ref, _ref2);
};

export default SvgCart;